export const policyAndSecurityContent = {
  title: "Política de Privacidade Pastejo",
  updatedAt: "Última atualização: 15 de julho de 2026",
  publicNotice:
    "Esta página é pública e pode ser acessada por usuários, clientes e revisores de loja sem autenticação.",
  sections: [
    {
      title: "1. Quem somos",
      paragraphs: [
        "Esta Política de Privacidade é mantida pelo Pastejo, responsável pela plataforma e pelos serviços relacionados à marca.",
        "Site oficial: https://www.pastejo.com.br/.",
        "O Pastejo oferece uma plataforma de gestão pecuária para controle de fazendas, áreas, pastos, rebanhos, manejo, suplementação e acompanhamento de dados operacionais.",
        "Esta Política de Privacidade explica como tratamos dados pessoais e dados operacionais quando você usa o aplicativo, a plataforma web e os serviços relacionados ao Pastejo.",
      ],
    },
    {
      title: "2. Dados que podemos coletar",
      paragraphs: [
        "Dados de conta e autenticação, como nome, telefone, identificador de usuário, vínculo com fazendas e perfil de acesso.",
        "Dados operacionais inseridos ou sincronizados na plataforma, incluindo propriedades, áreas, pastos, lotes, rebanhos, manejos, avaliações de pastagem, estoque, suplementação e registros de atividades.",
        "Dados técnicos do dispositivo e do uso do serviço, como endereço IP, data e hora de acesso, logs de erro, versão do aplicativo, identificadores de sessão e informações necessárias para segurança.",
        "Dados de localização e informações geográficas quando você autoriza ou utiliza recursos de mapas, desenho de áreas, importação de arquivos geográficos e operações em campo.",
        "Arquivos, imagens e documentos enviados voluntariamente para utilizar funcionalidades da plataforma.",
      ],
    },
    {
      title: "3. Como usamos os dados",
      paragraphs: [
        "Usamos os dados para autenticar usuários, controlar permissões, operar os recursos da plataforma, sincronizar informações, gerar mapas, relatórios e painéis operacionais, registrar atividades e melhorar estabilidade e segurança.",
        "Dados de localização e informações geográficas são usados para funcionalidades operacionais, como cadastro e visualização de propriedades, áreas e pastos, validação de mapas e atividades em campo.",
        "Não vendemos dados pessoais. Também não usamos dados operacionais de clientes para publicidade comportamental.",
      ],
    },
    {
      title: "4. Compartilhamento e operadores",
      paragraphs: [
        "Podemos utilizar provedores de infraestrutura e serviços necessários à operação, incluindo hospedagem em nuvem, banco de dados, autenticação, mapas, armazenamento, análise técnica e comunicação.",
        "Esses provedores recebem apenas os dados necessários para executar suas funções e devem observar medidas adequadas de segurança e confidencialidade.",
        "Informações também poderão ser compartilhadas para cumprimento de obrigação legal, regulatória ou determinação de autoridade competente.",
      ],
    },
    {
      title: "5. Segurança",
      paragraphs: [
        "Adotamos controles técnicos e organizacionais para proteger os dados, incluindo comunicação segura, autenticação, controle de acesso por perfil, proteção de credenciais e segregação de permissões.",
        "Apesar dos controles aplicados, nenhum sistema é completamente imune a riscos. Caso identifiquemos incidente relevante, adotaremos as medidas cabíveis conforme a legislação aplicável.",
      ],
    },
    {
      title: "6. Retenção",
      paragraphs: [
        "Mantemos dados pelo tempo necessário para prestar os serviços, cumprir obrigações legais, resolver disputas, manter auditoria, proteger a plataforma e preservar registros operacionais exigidos pelo contexto do cliente.",
        "Quando aplicável, dados podem ser removidos ou anonimizados mediante solicitação legítima e conforme limitações técnicas, legais e contratuais.",
      ],
    },
    {
      title: "7. Seus direitos",
      paragraphs: [
        "Você pode solicitar confirmação de tratamento, acesso, correção, atualização, portabilidade, anonimização, bloqueio, eliminação ou informações sobre compartilhamento, conforme a Lei Geral de Proteção de Dados.",
        "Alguns pedidos podem depender da validação de identidade, do vínculo com a organização contratante e de obrigações legais ou contratuais aplicáveis.",
      ],
    },
    {
      title: "8. Permissões do aplicativo",
      paragraphs: [
        "Localização: usada para recursos de mapas, cadastro de áreas, validação geográfica e operações em campo.",
        "Câmera e arquivos: usados, quando autorizados, para anexar imagens, documentos e arquivos geográficos às funcionalidades da plataforma.",
        "Notificações: usadas, quando autorizadas, para avisar sobre novas tarefas atribuídas ao usuário.",
        "Internet: necessária para autenticação, sincronização, mapas, APIs e atualização dos dados.",
      ],
    },
    {
      title: "9. Crianças e adolescentes",
      paragraphs: [
        "A plataforma é destinada ao uso profissional e operacional. Não é direcionada a crianças nem coleta intencionalmente dados de crianças para fins de consumo ou entretenimento.",
      ],
    },
    {
      title: "10. Alterações nesta política",
      paragraphs: [
        "Podemos atualizar esta Política de Privacidade para refletir mudanças legais, técnicas ou operacionais. A versão publicada nesta página indica a data da última atualização.",
      ],
    },
    {
      title: "11. Contato",
      paragraphs: [
        "Para dúvidas, suporte ou solicitações relacionadas à privacidade, entre em contato com o Pastejo pelos canais oficiais disponíveis no site https://www.pastejo.com.br/.",
      ],
    },
  ],
} as const;
